module.exports = __webpack_public_path__ + "static/media/chatbi.d1716cd1.svg";